import React from 'react';
import { Container, ListGroup } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
// import { toast } from 'react-toastify';
import arrow from "../assets/images/arrow.png";
import userPic from "../assets/images/user.png";
import help from "../assets/images/help.png";
import payment from "../assets/images/payment.png";
import child from "../assets/images/child.png";
import { showToast } from '../config/Alert';
import { logoutUser } from '../services/AuthApi';
import 'react-toastify/dist/ReactToastify.css';
import password from "../assets/images/password.png";

const Account = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const role = user.role;
  const emailVerifiedAt = user.email_verified_at || null;

  const handleLogout = async () => {
    try {
      await logoutUser();
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      showToast("Logged out successfully", "success");
      navigate("/login");
    } catch (error) {
      showToast("Logout failed. Please try again.", "error");
    }
  };

  return (
    <div className='app-container mobile-bottom'>
      <Container className='mb-3'>
        <h6>Welcome To, <span className='text-danger'>{user?.name || "Guest"}!</span></h6>
        <ListGroup variant="flush" className='list_group_type'>
          {role === "Parent" && (
            <>
              <ListGroup.Item>
                <Link to='/parentProfile' className='d-flex justify-content-between align-items-start'>
                  <div className='me-auto d-flex align-items-center'>
                    <img src={userPic} width={20} alt="user" />
                    <span className='ps-1'>Parent Profile 
                      {emailVerifiedAt === null && (
                      <span className='badge bg-danger fs-8 ms-3'>Verify your Email</span>
                    )}
                    </span>
                  </div>
                  <img src={arrow} width={14} alt="parentProfile" />
                </Link>
              </ListGroup.Item>

              <ListGroup.Item >
                <Link to='/viewChildProfile' className='d-flex justify-content-between align-items-start'>
                  <div className='me-auto d-flex align-items-center'>
                    <img src={child} width={20} alt="user" />
                    <span className='ps-1'> Children</span>
                  </div>
                  <img src={arrow} width={14} alt="childProfile" />
                </Link>
              </ListGroup.Item>

              <ListGroup.Item>
                <Link to='/paymentHistory' state={{ source: 'history' }} className='d-flex justify-content-between align-items-start'>
                  <div className='me-auto d-flex align-items-center'>
                    <img src={payment} width={20} alt="user" />
                    <span className='ps-1'> Payment History</span>
                  </div>
                  <img src={arrow} width={14} alt="paymentHistory" />
                </Link>
              </ListGroup.Item>
            </>
          )}

          {/* {role === 'Teacher' && (
            <>
              <ListGroup.Item >
                <Link to='/personalProfile' className='d-flex justify-content-between align-items-start'>
                  <div className='me-auto d-flex align-items-center'>
                    <img src={userPic} width={20} alt="user" />
                    <span className='ps-1'> Personal Details</span>
                  </div>
                  <img src={arrow} width={14} alt="childProfile" />
                </Link>
              </ListGroup.Item>
              <ListGroup.Item>
                <Link to='/publicProfile' className='d-flex justify-content-between align-items-start'>
                  <div className='me-auto d-flex align-items-center'>
                    <img src={profilePublic} width={20} alt="user" />
                    <span className='ps-1'> Public Profile</span>
                  </div>
                  <img src={arrow} width={14} alt="childProfile" />
                </Link>
              </ListGroup.Item>
            </>
          )} */}

          <ListGroup.Item>
            <Link to='/changePassword' className='d-flex justify-content-between align-items-start'>
              <div className='me-auto d-flex align-items-center'>
                <img src={password} width={20} alt="password" />
                <span className='ps-1'> Change Password</span>
              </div>
              <img src={arrow} width={14} alt="arrow" />
            </Link>
          </ListGroup.Item>

          <ListGroup.Item>
            <Link to='/helpSupport' className='d-flex justify-content-between align-items-start'>
              <div className='me-auto d-flex align-items-center'>
                <img src={help} width={20} alt="user" />
                <span className='ps-1'> Help & Support</span>
              </div>
              <img src={arrow} width={14} alt="Logo" />
            </Link>
          </ListGroup.Item>

          <ListGroup.Item className='fw-bold'>
            <Link className='d-flex ps-4 text-danger text-decoration-none' onClick={handleLogout}>Logout</Link>
          </ListGroup.Item>
        </ListGroup>
      </Container>
    </div >
  );
}

export default Account;
